module.exports = __webpack_public_path__ + "img/main-page-bg.dcdd57f5.png";